// カートドロワーのおすすめ「追加」: /cart/add.js（sections 付き）→ Dawn 純正 cart-drawer.renderContents() でドロワー全体（商品行・小計・おすすめ枠）を再描画。
// 追加後は Liquid 側の規則（カート未投入のみ）で候補から自動的に外れる。
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-cs-add]');
  if (!btn) return;
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  btn.disabled = true;
  var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
  })
    .then(function (r) { return r.json(); })
    .then(function (json) {
      if (json.status) throw new Error(json.description || 'add failed');
      drawer.renderContents(json);
      if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-cross-sell', productVariantId: btn.dataset.variantId, cartData: json });
    })
    .catch(function () { btn.disabled = false; });
}, true);
